/**
 * API_CONTRACT.md §9.2 — `Idempotency-Key: <client-generated uuid/ulid>` is REQUIRED on
 * `POST /files/{id}/movements` ("a double-submitted forward must not create two
 * movements"). One helper so every write call site generates the key the same way.
 *
 * `crypto.randomUUID()` needs a secure context; `http://127.0.0.1` and `https://` both
 * qualify, but this falls back to a plain (non-cryptographic, and that is fine — this key
 * only needs to be unique per submission, never secret) v4-shaped generator so a future
 * deployment behind plain HTTP on a non-localhost host does not lose idempotency
 * protection outright.
 */
export function generateIdempotencyKey(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
